import React, { Component } from "react";
import FilterBuilder from "./FilterBuilder";

export class AdvancedCommonFileSettings extends Component {
  state = {
    spiderDoNotSpiderUrl: [],
    spiderOnlySpiderUrl: [],
    spiderDoNotReadUrl: [],
    spiderOnlyReadUrl: [],
    onlyReadContentType: [],
    doNotReadContentType: [],
  };

  componentDidMount() {
    this.parseEditKs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.settingsUpdated();
    }
    if (this.props.editKs !== prevProps.editKs) {
      this.parseEditKs();
    }
  }

  parseEditKs = () => {
    if (this.props.editKs && Object.keys(this.props.editKs).length > 0) {
      let onlyReadRegexes = {
        onlyReadFile: this.props.editKs.properties.spiderProperties
          .spiderOnlyReadFilePath,
        onlyReadContentType: this.props.editKs.properties.spiderProperties
          .onlyReadContentType,
      };
      let doNotReadRegexes = {
        doNotReadFile: this.props.editKs.properties.spiderProperties
          .spiderDoNotReadFilePath,
        doNotReadContentType: this.props.editKs.properties.spiderProperties
          .doNotReadContentType,
      };
      let doNotSpiderRegexes = {
        doNotSpiderFile: this.props.editKs.properties.spiderProperties
          .spiderDoNotSpiderFilePath,
      };
      this.onOnlyReadUpdate(onlyReadRegexes);
      this.onDoNotReadUpdate(doNotReadRegexes);
      this.onDoNotSpiderUpdate(doNotSpiderRegexes);
    }
  };

  render() {
    return (
      <div>
        <FilterBuilder
          isFiles
          sourceType={this.props.sourceType}
          onOnlyReadUpdate={this.onOnlyReadUpdate}
          onDoNotReadUpdate={this.onDoNotReadUpdate}
          editKs={this.props.editKs}
          onDoNotSpiderUpdate={this.onDoNotSpiderUpdate}
        />
      </div>
    );
  }

  onOnlyReadUpdate = (regexes) => {
    let { onlyReadFile, onlyReadContentType, ...unknown } = regexes;
    this.setState({
      spiderOnlyReadFilePath: onlyReadFile,
      onlyReadContentType,
    });
    if (this.props.onOnlyReadUpdate) {
      this.props.onOnlyReadUpdate(unknown);
    }
  };

  onDoNotReadUpdate = (regexes) => {
    let { doNotReadFile, doNotReadContentType, ...unknown } = regexes;
    this.setState({
      spiderDoNotReadFilePath: doNotReadFile,
      doNotReadContentType,
    });
    if (this.props.onDoNotReadUpdate) {
      this.props.onDoNotReadUpdate(unknown);
    }
  };

  onDoNotSpiderUpdate = (regexes) => {
    let { doNotSpiderFile, ...unknown } = regexes;
    this.setState({ spiderDoNotSpiderFilePath: doNotSpiderFile });
    if (this.props.onDoNotSpiderUpdate) {
      this.props.onDoNotSpiderUpdate(unknown);
    }
  };

  settingsUpdated = () => {
    this.props.setSpiderProperties({ ...this.state });
  };
}

export default AdvancedCommonFileSettings;
